import React, { useState } from 'react';
import Cookies from 'js-cookie';
import VBInput from '@vb-js-commons/new/vbInput';
import VBCheckbox from '@vb-js-commons/new/vbCheckbox';
import VBSearchInput from '@vb-js-commons/new/vbSearchInput';
import { searchProps } from '../api/services/property';

import Navigation from '../components/static/Navigation';
import Footer from '../components/static/Footer';

export default function UserMapLayerUpload() {
    const [directUpl, setdirectUpl] = useState(false);
    const [loading, setLoading] = useState(false);
    const [userID, setUserID] = useState(null);
    const [designation, setDesignation] = useState(null);
    const [layerName, setlayerName] = useState(null);
    const [file, setFile] = useState(null);
    const [focus, setFocus] = useState('');
    const [searchString, setSearchString] = useState('');
    const [searchResult, setSearchResult] = useState([]);
    const [searchTimeout, setSearchTimeout] = useState(null);

    const submitForm = (e) => {
        e.preventDefault();
        setLoading(true)

        const formData = new FormData();
        formData.append('directUpl', directUpl);
        formData.append('file', file);
        formData.append('userID', userID);
        formData.append('designation', designation);
        formData.append('layerName', layerName);
       
        const headers = {
            'X-CSRFToken': Cookies.get('csrftoken'),
        }

        fetch("/map-api/user-map-layer-upload/", 
            {
                "method":"POST",
                credentials: 'same-origin',
                headers: headers,
                "body": formData
            }
        ).then(resp => resp.json()).then((json) => {
            setLoading(false)
            if (json.error) {
                alert(json.error)
            } else {
                alert(json.ok)
            }
        })
    }
    
    return <div className='container-fluid d-flex flex-column vh-100 justify-content-between p-0'>
        <Navigation />
    
        <div className="w-100 d-flex align-items-center justify-content-center">
            <div className="bg-neutral-cloud-200 my-3 p-3 rounded-3">
                <form onSubmit={submitForm}>
                    
                    <VBInput 
                    type="text" 
                    label={<label className='subtitle pb-1'>User ID</label>}
                    onChange={(val) => {setUserID(val)}}/>            
                    {/* <VBInput 
                    type="text" 
                    label={<label className='subtitle pb-1'>Property Designation</label>}
                    onChange={(val) => {setDesignation(val)}}/> */}

                    <p className='subtitle pt-1'>Property Designation</p>
                    <VBSearchInput
                        id='propSearchInput'
                        placeholder='Search eg: Sevedstorp 1:8'
                        initial={searchString}
                        hasFocus={focus}
                        onBlur={() => setFocus('')}
                        onChange={async (val) => {
                            setFocus('propSearchInput')
                            setSearchString(val)

                            if (searchTimeout) {
                                clearTimeout(searchTimeout)
                            }
                            const timeout = setTimeout(async () => {
                                const searchResult = await searchProps(val)
                                setSearchResult(searchResult.data)
                            }, 400)

                            setSearchTimeout(timeout)
                        }}
                        searchResult={
                            searchString !== '' &&
                                searchResult && searchResult.length > 0 ?
                                searchResult.map(prop => <p className="option w-100 ps-2" onClick={() => setDesignation(prop.beteckning)}>{prop.beteckning}</p>) :
                                <p>Inga träffar på den sökningen.</p>
                        }
                    />
                    {designation && <p className='n-fs-6'>{designation}</p>}

                    <p className="w-50 n-fs-8 my-1">Warning! A property with the exact same designation must exist on the user before uploading.</p>
                    <VBInput 
                    type="text" 
                    label={<label className='subtitle py-1'>Layer visual name</label>}
                    onChange={(val) => {setlayerName(val)}}/>

                    <div className="d-flex flex-column align-items-start">
                        <input type="file" id="propFile" className="position-absolute opacity-0" style={{ width: "20px" }} onChange={(e) => { setFile(e.target.files[0]) }} />
                        {file && <a className='mt-2 bg-supp-forest-green-300 p-2 me-2 white rounded-pill n-fs-7 d-inline-block'>{file?.name}
                            <img src={Window.static_path + 'img/icons/X.svg'} className='ms-2 white-filter' role='button' width='16px' height='16px'
                                onClick={() => {
                                    setFile(null);
                                }} /></a>}
                        <label className="n-btn btn-forest-green btn-sm mt-3" htmlFor="propFile" role='button'> <img className={`me-2`} style={{ width: "18px", height: "18px" }} src={Window.static_path + "img/icons/icon-left.svg"} />Choose File</label>
                    </div>
                    {Window.user_data.isAdmin ? <div className="mt-2">
                        <label className="n-fs-8 my-3 d-flex align-items-center mb-1">
                        <VBCheckbox
                        label="Direct upload to Geoserver, only applies to tif. (Geotiff pyramids need to be pre-generated or the layer will be slow in the map!)"
                        initial={directUpl}
                        checked={directUpl}
                        onClick={()=>setdirectUpl(!directUpl)}
                        />
                    
                        </label>
                    </div> : null}
                    <button className="n-btn btn-core" type="submit">Upload</button>
                    <p className="w-50 n-fs-8 mb-0 mt-3">Warning! To upload .shp, compress the files to zip, all files and the zip must be named the same. ex. layer_name.zip</p>
                </form>
                {loading ? <p>Loading! Please wait, this can take several minutes...</p>: null}
            </div>
        </div>

        <Footer />
    </div>
}